import {
  CompactDateInput,
  FieldWrapper,
  FilterMultiSelect,
  FilterSelect,
  FilterSortGroup,
  dateChipLabel,
  formatGroupedValues,
  resolveOptionLabel,
} from "./jobsFilterUtils";

export const JOBS_SHIFT_ASSIGNMENT_SORT_OPTIONS = [
  { value: "shift_account_id", label: "Assignment" },
  { value: "last_modified_proximity", label: "Last Modified Proximity" },
  { value: "shift_start_date", label: "Scheduled Start Date" },
];

export const JOBS_SHIFT_ASSIGNMENT_PROXIMITY_OPTIONS = [
  { value: "", label: "All" },
  { value: "after", label: "After Shift Start Time" },
  { value: "24h_after", label: "24h or more After Shift Start Date" },
];

export function JobsShiftAssignmentFilterFields({
  focusedFieldId,
  onFocusClear,
  filters,
  setFilters,
  setWideDateRange,
  onFilterPatch,
  staffOptions = [],
  officeStaffOptions = [],
  staffFilterLoading = false,
  officeStaffFilterLoading = false,
  onStaffQueryChange,
  onOfficeStaffQueryChange,
}) {
  const patch = (partial) => {
    if (typeof onFilterPatch === "function") {
      onFilterPatch(partial);
      return;
    }
    setWideDateRange?.(null);
    setFilters((prev) => ({ ...prev, ...partial }));
  };

  return (
    <>
      <FieldWrapper fieldId="lastModifiedProximity" label="Last Modified Proximity" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSelect id="jobs-sa-proximity" value={filters.lastModifiedProximity || ""} onChange={(v) => patch({ lastModifiedProximity: v })} options={JOBS_SHIFT_ASSIGNMENT_PROXIMITY_OPTIONS} placeholder={null} />
      </FieldWrapper>
      <FieldWrapper fieldId="fromShiftStart" label="From Shift Start Time" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <CompactDateInput
          id="jobs-sa-from"
          value={filters.fromShiftStart}
          onChange={(newFrom) => {
            if (newFrom && filters.toShiftStart && newFrom > filters.toShiftStart) {
              patch({ fromShiftStart: newFrom, toShiftStart: "" });
            } else {
              patch({ fromShiftStart: newFrom });
            }
          }}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="toShiftStart" label="To Shift Start Time" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <CompactDateInput id="jobs-sa-to" value={filters.toShiftStart} onChange={(v) => patch({ toShiftStart: v })} min={filters.fromShiftStart} />
      </FieldWrapper>
      <FieldWrapper fieldId="staff" label="Staff" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect
          id="jobs-sa-staff"
          options={staffOptions}
          value={filters.staffAccountIds || []}
          onChange={(v) => patch({ staffAccountIds: v })}
          placeholder="Search staff..."
          loading={staffFilterLoading}
          onQueryChange={onStaffQueryChange}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="lastModifiedByStaff" label="Last Modified by Staff" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect
          id="jobs-sa-last-modified"
          options={officeStaffOptions}
          value={filters.lastModifiedByAccountIds || []}
          onChange={(v) => patch({ lastModifiedByAccountIds: v })}
          placeholder="Search office staff..."
          loading={officeStaffFilterLoading}
          onQueryChange={onOfficeStaffQueryChange}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="sort" label="" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSortGroup
          id="jobs-sa-sort"
          sortBy={filters.sortBy || "last_modified_proximity"}
          sortOrder={filters.sortDirection || "asc"}
          onSortByChange={(v) => patch({ sortBy: v })}
          onSortOrderChange={(v) => patch({ sortDirection: v })}
          sortOptions={JOBS_SHIFT_ASSIGNMENT_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildJobsShiftAssignmentFilterChips({ filters, staffOptions = [], officeStaffOptions = [] }) {
  const chips = [];
  if (filters.lastModifiedProximity) {
    chips.push({
      id: "sa-proximity",
      key: "lastModifiedProximity",
      fieldId: "lastModifiedProximity",
      label: `Last Modified Proximity: ${resolveOptionLabel(JOBS_SHIFT_ASSIGNMENT_PROXIMITY_OPTIONS, filters.lastModifiedProximity)}`,
    });
  }
  if (filters.fromShiftStart) chips.push({ id: "sa-from", key: "fromShiftStart", fieldId: "fromShiftStart", label: `From Shift Start Time: ${dateChipLabel(filters.fromShiftStart)}` });
  if (filters.toShiftStart) chips.push({ id: "sa-to", key: "toShiftStart", fieldId: "toShiftStart", label: `To Shift Start Time: ${dateChipLabel(filters.toShiftStart)}` });
  if ((filters.staffAccountIds || []).length) {
    chips.push({ id: "sa-staff", key: "staff", fieldId: "staff", label: `Staff: ${formatGroupedValues(filters.staffAccountIds, (v) => resolveOptionLabel(staffOptions, v), 3)}` });
  }
  if ((filters.lastModifiedByAccountIds || []).length) {
    chips.push({ id: "sa-last-modified", key: "lastModifiedByStaff", fieldId: "lastModifiedByStaff", label: `Last Modified by Staff: ${formatGroupedValues(filters.lastModifiedByAccountIds, (v) => resolveOptionLabel(officeStaffOptions, v), 3)}` });
  }
  return chips;
}
